import { useCallback, useEffect, useState } from "react";
import { SimpleHttp } from "src/lib/utils/SimpleHTTP";

/**
 * Fetch all stacks from server
 * @param {string} stack
 * Stack Id
 * @param {boolean} enabled
 */
export default function useGetSkills() {
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const [retryCount, setRetry] = useState(0);

  const retry = () => {
    setRetry((prev) => ++prev);
  };

  const fetchData = useCallback(
    async () => {
      setLoading(true);
      setError(undefined);

      try {
        const { status, data, error } = await SimpleHttp.getNoAuth(
          `/api/v1/all/getAllSkills`
        );
        
        if (status === true) {
          setSkills(data);
        } else {
          // toast.error(error?.message)
          console.log("Skill Error:", error);
        }
      } catch (error) {
        console.log("Skill Error:", error);
        setError(error);
      }

      setLoading(false);
    },
    [],
  )

  useEffect(() => {
    setLoading(true);
    fetchData();
  }, [retryCount]);

  return { skills, loading, error, retry };
}
